import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link} from "react-router-dom";
import PaginationAdvanced from "../../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import moment from "moment";
import Search from "../../components/Search";
import _ from "lodash";
import { toastr } from "react-redux-toastr";

import Index from "../Index";
import { fetchEmailAddresses, markEmailAddressAsValid } from "../../actions/index";

export class AdminEmailAddressesIndex extends Index {
  static propTypes = {
    fetchEmailAddresses: PropTypes.func.isRequired,
    markEmailAddressAsValid:  PropTypes.func.isRequired,
    location:            PropTypes.object.isRequired,
    emailAddresses:      PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchEmailAddresses(
      this.serialize(newQueries)
    );
    this.props.history.push(`/admin/email_addresses${this.serialize(newQueries)}`);
  }

  updateAddress(e) {
    let siteUUID = e.target.dataset.siteUuid;
    let emailAddressId = e.target.dataset.emailAddressId;
    let emailAddressAddress = e.target.dataset.emailAddress;
    if (
      confirm(
        "Are you sure you want to mark this email as valid every where?\n It will override Brite Verify invalid status and set bad_email: false at LeadManager as well."
      )
    ) {
      this.props.markEmailAddressAsValid(emailAddressId).then(emailAddress => {
        if (emailAddress.payload != undefined) {
          if (emailAddress.payload.status == '200') {
            toastr.success(emailAddressAddress + ' marked as valid!');
            this.setState({
              search: this.props.location.search
            });
            this.fetchData();
          } else {
            toastr.error(emailAddress.payload.data);
          }
        }
      });
    }
  }

  renderMarkAsValidBtn(emailAddress) {
    return (
      <a
        className="btn btn-default m-l-10"
        data-email-address-id={emailAddress.id}
        data-email-address={emailAddress.address}
        onClick={this.updateAddress.bind(this)}
      >
        Mark as Valid
      </a>
    );
  }

  renderEmailAddresses() {
    let query = new URLSearchParams(this.props.location.search);
    if (!this.props.emailAddresses.data) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              />
            </div>
          </td>
        </tr>
      );
    } else if (query.get('search').length == 0) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="well well-lg text-center">
              Enter a complete email address to search.&nbsp;
            </div>
          </td>
        </tr>
      );
    } else if (this.props.emailAddresses.data.length == 0) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="well well-lg text-center">
              No Email Addresses found.&nbsp;
            </div>
          </td>
        </tr>
      );
    }

    return this.props.emailAddresses.data.map(emailAddress => {
      let badEmailStatusLabel =
        emailAddress.bad_email == false ? "label-success" : "label-danger";
      let goodStatusLabel =
        emailAddress.good == true ? "label-success" : "label-danger";
      let bvStatusLabel =
        emailAddress.bv_status == 'valid' ? "label-success" : "label-danger";
      return (
        <tr key={emailAddress.id}>
          <td>{emailAddress.address}</td>
          <td>
            <span className={`label ${badEmailStatusLabel}`}>{emailAddress.bad_email.toString()}</span>
          </td>
          <td>
            <span className={`label ${goodStatusLabel}`}>{emailAddress.good.toString()}</span>
          </td>
          <td>{moment(emailAddress.created_at).format("MM/DD/YYYY h:mm:ss A")}</td>
          <td>{moment(emailAddress.updated_at).format("MM/DD/YYYY h:mm:ss A")}</td>
          <td>
            <span className={`label ${bvStatusLabel}`}>{emailAddress.bv_status}</span>
          </td>
          <td>{emailAddress.bv_error}</td>
          <td>{emailAddress.bv_error_code}</td>
          <td>{moment(emailAddress.last_engaged_at).format("MM/DD/YYYY h:mm:ss A")}</td>
          <td>{emailAddress.aasm_state}</td>
          <td>{emailAddress.unengaged_reason}</td>
          <td className="text-right">
            {this.renderMarkAsValidBtn(emailAddress)}
          </td>
        </tr>
      );
    });
  }

  render() {
    let count = 0;
    if (this.props.emailAddresses.meta) {
      count = this.props.emailAddresses.meta.count;
    }
    return (
      <div className="emailAddresses_index">
        <div className="row">
          <h1>
            Email Addresses
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                params={this.props.params}
              />
            </div>
          </h1>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`email_address_address ${this.indicateSorting(
                    "email_addresses.address"
                  )}`}
                  data-sort="email_addresses.address"
                  onClick={this.handleOrder.bind(this)}
                >
                  Email
                </th>
                <th className={`email_address_bad_email`} >
                  Bad Email
                </th>
                <th
                  className={`email_address_good ${this.indicateSorting("good")}`}
                  data-sort="good"
                  onClick={this.handleOrder.bind(this)}
                >
                  Good
                </th>
                <th
                  className={`email_address_date ${this.indicateSorting("created_at")}`}
                  data-sort="created_at"
                  onClick={this.handleOrder.bind(this)}
                >
                  Created
                </th>
                <th
                  className={`email_address_date ${this.indicateSorting("updated_at")}`}
                  data-sort="updated_at"
                  onClick={this.handleOrder.bind(this)}
                >
                  Updated
                </th>
                <th
                  className={`email_address_bv_status ${this.indicateSorting(
                    "email_addresses.bv_status"
                  )}`}
                  data-sort="email_addresses.bv_status"
                  onClick={this.handleOrder.bind(this)}
                >
                  BV Status
                </th>
                <th
                  className={`email_address_bv_error ${this.indicateSorting(
                    "email_addresses.bv_error"
                  )}`}
                  data-sort="email_addresses.bv_error"
                  onClick={this.handleOrder.bind(this)}
                >
                  BV Error
                </th>
                <th
                  className={`email_address_bv_error_code ${this.indicateSorting(
                    "email_addresses.bv_error_code"
                  )}`}
                  data-sort="email_addresses.bv_error_code"
                  onClick={this.handleOrder.bind(this)}
                >
                  BV Err. Code
                </th>
                <th
                  className={`email_address_last_engaged_at ${this.indicateSorting(
                    "email_addresses.last_engaged_at"
                  )}`}
                  data-sort="email_addresses.last_engaged_at"
                  onClick={this.handleOrder.bind(this)}
                >
                  Last Engaged
                </th>
                <th
                  className={`email_address_aasm_state ${this.indicateSorting(
                    "email_addresses.aasm_state"
                  )}`}
                  data-sort="email_addresses.aasm_state"
                  onClick={this.handleOrder.bind(this)}
                >
                  AASM
                </th>
                <th
                  className={`email_address_unengaged_reason ${this.indicateSorting(
                    "email_addresses.unengaged_reason"
                  )}`}
                  data-sort="email_addresses.unengaged_reason"
                  onClick={this.handleOrder.bind(this)}
                >
                  Unengaged Reason
                </th>
              </tr>
            </thead>
            <tbody>{this.renderEmailAddresses()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { emailAddresses: state.emailAddresses.all };
}

export default connect(
  mapStateToProps,
  { fetchEmailAddresses, markEmailAddressAsValid }
)(AdminEmailAddressesIndex);
